var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Page',{scopedSlots:_vm._u([{key:"title",fn:function(){return [_vm._v("Справочники")]},proxy:true}])},[_c('BaseNavigation',{staticClass:"mb-6",attrs:{"items":_vm.menu}}),_c('DictionaryForm',{attrs:{"data":_vm.formData}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }